jQuery(document).ready(function($) {
    // Set triggers for each type of slider
    if ($('.hero-slider').length) {
        $('.hero-slider').slick({
            slidesToShow: 1,
            lazyLoad: 'ondemand',
            arrows: true,
            fade: true,
            prevArrow: $('.hero-slider-prev'),
            nextArrow: $('.hero-slider-next'),
        });
    }
});